export const projectsData = [
  {
    id: 1,
    titre: "Mini rédac",
    categorie: "Programmation Symfony",
    languages: [
      "Symfony 8.1",
      "Doctrine",
      "MySQL",
      "MongoDB",
      "Docker",
      "FrankenPHP",
      "React",
      "PHPUnit",
      "PHPStan",
      "GitLab CI",
    ],
    description:
      "« Mini-rédac est une application de gestion éditoriale pour un titre de presse, que je développe actuellement pour monter en compétence sur Symfony. Les journalistes rédigent des articles classés par rubriques, un éditeur les relit puis les publie, et le public consulte les articles. Les statistiques de lecture alimentent un widget « Les plus lus ». Le projet avance par étapes : chaque fonctionnalité est développée dans sa propre branche et intégrée via une merge request.\n\n <ins>**Environnement.**</ins> Le projet repose sur le template **dunglas/symfony-docker** : \n\n - l'application tourne dans des conteneurs **Docker** (OrbStack) avec **FrankenPHP** comme serveur, en HTTPS local ;\n\n - j'ai corrigé une incompatibilité entre le template et la version récente de **Mercure**, qui faisait planter le conteneur en boucle, tout en conservant le rechargement à chaud ;\n\n - le dépôt est poussé simultanément sur **GitLab** et GitHub.\n\n <ins>**PHP / Symfony.**</ins> En cours de développement :\n\n - modèle de données **Doctrine** (Article, Rubrique, User) avec migrations, sur **MySQL** ;\n\n- authentification et rôles (journaliste, éditeur), avec un **Voter** pour les droits sur chaque article ;\n\n - back-office de rédaction, avec le composant **Workflow** pour gérer les statuts (brouillon, en relecture, publié) ;\n\n - traitements asynchrones à la publication avec **Messenger** ;\n\n - une API en lecture seule pour exposer les articles.\n\n <ins>**JavaScript.**</ins> Un widget **React** « Les plus lus », alimenté par l'API et par des statistiques de lecture stockées dans **MongoDB**.\n\n <ins>**Qualité et outillage.**</ins> Tests **PHPUnit**, analyse statique **PHPStan**, pipeline **GitLab CI** et revue de sécurité selon les recommandations OWASP.",
    image: "./img/mini-redac-architecture.webp",
    alternative: "copie d'écran de la page d'accueil du projet Art Massif",
    width: "1920",
    height: "950",
    github: "https://gitlab.com/olivier-group4913941/telegram-redaction",
  },
  {
    id: 2,
    titre: "Art Massif",
    categorie: "Programmation site web",
    languages: [
      "PHP",
      "WordPress",
      "CPT UI",
      "ACF",
      "SCSS",
      "GSAP",
      "Vanilla JS",
      "Swiper",
      "Gulp",
      "Composer",
      "NodeJS",
      "SEO",
    ],
    description:
      "« Art Massif donne vie à des structures audacieuses, durables et raffinées, pour repousser les limites de l’architecture en bois ». Le site présente un catalogue de produits, plus d'une centaine de réalisations filtrables, des offres d'emploi et un centre de documentation, en français et en anglais.\n\n<ins>**PHP / WordPress**</ins>. Thème enfant structuré en modules (inc/), chargés depuis functions.php. Le contenu est modélisé avec cinq types de contenu personnalisés (projets, produits standards et spéciaux, documents, postes) et cinq taxonomies (région, secteur, type, produit). Une quinzaine de shortcodes construisent leurs propres requêtes WP_Query pour générer les carrousels, menus et listes déroulantes à partir des champs personnalisés et des taxonomies, avec échappement systématique des sorties. Le bilinguisme passe par WPML et les fonctions d'internationalisation de WordPress.\n\n<ins>**JavaScript**</ins>. Une architecture en modules ES natifs : environ 25 modules importés par un point d'entrée unique, chargé en type=\"module\" grâce au filtre script_loader_tag. Une couche d'interface sur JetSmartFilters permet le traitement des listes déroulantes personnalisées avec gestion d'ARIA, des étiquettes de filtres actifs et une réinitialisation. Sur chaque fiche projet, le filtre produit s'active automatiquement : le script lit la taxonomie dans les classes du body, fait la correspondance des slugs FR/EN et normalise le texte (accents, caractères spéciaux). Les animations s'appuient sur la librairie d’animation GSAP (ScrollTrigger, SplitText), avec un Lenis scroll et des carrousels Swiper.",
    image: "./img/artmassif.webp",
    alternative: "copie d'écran de la page d'accueil du projet Art Massif",
    width: "1920",
    height: "950",
    lien: "https://www.artmassif.ca/",
  },
  {
    id: 3,
    titre: "Avenir Franchise",
    categorie: "Programmation site web",
    languages: [
      "PHP",
      "WordPress",
      "ACF",
      "CPT UI",
      "Contact Form 7",
      "JavaScript (modules ES)",
      "GSAP",
      "Swiper",
      "SCSS",
      "Elementor Pro (hooks, Dynamic Tags)",
    ],
    description:
      "Annuaire des franchises au Québec : 57 fiches franchises, plus de 120 articles de blog et une navigation croisée par secteur d'activité (une hiérarchie de 84 secteurs et sous-secteurs), par région (17) et par niveau d'investissement. Les franchises clientes sont mises en avant, et chaque fiche mène à un formulaire de demande d'information.\n\n<ins>**PHP / WordPress**</ins>. Thème enfant de Hello Elementor structuré en modules (inc/) chargés depuis functions.php, avec des contenus modélisés dans CPT UI et ACF. Les grilles Elementor sont pilotées par des requêtes sur mesure (hooks elementor/query) : franchises clientes ou non par secteur, région et investissement, secteurs parents sans leurs sous-secteurs, sous-secteurs de la page courante. Un shortcode compte les franchises de chaque terme, enfants compris, avec une WP_Query optimisée (IDs seuls, sans cache de métadonnées), et un filtre body_class adapte la mise en page quand un secteur n'a pas de sous-secteurs. J'ai aussi développé une Dynamic Tag Elementor (classe PHP) qui génère le lien du formulaire avec l'ID de la franchise, dont le nom est ensuite prérempli à partir de l'URL ou du référent. Les autres shortcodes affichent la franchise liée à un article, les témoignages, les compétences et une FAQ en accordéon à partir de champs répéteurs ACF, et le fil d'Ariane Rank Math est réécrit par filtres.\n\n<ins>**JavaScript**</ins>. Des modules ES natifs chargés en type=module. Le formulaire de demande d'information est un formulaire multi-étapes construit par-dessus Contact Form 7 : validation de chaque étape avant de passer à la suivante, barre de progression, et retour automatique à l'étape fautive quand CF7 refuse l'envoi (événement wpcf7invalid). On trouve aussi un filtre alphabétique des franchises, des animations de texte GSAP (SplitText, ScrollTrigger) et des carrousels Swiper.",
    image: "./img/avenirfranchise.webp",
    alternative: "copie d'écran de la page d'accueil du projet Avenir Franchise",
    width: "1920",
    height: "950",
    lien: "https://avenir-franchise.ca/",
  },
  {
    id: 4,
    titre: "Pizzeria Ty Birill",
    categorie: "Programmation site web",
    languages: [
      "Thème WP custom",
      "PHP",
      "Composer",
      "ACF",
      "Settings API",
      "JavaScript ES6+ (modules)",
      "GSAP et ScrollTrigger",
      "Swiper",
      "SCSS",
      "Gulp",
      "Git",
    ],
    description:
      "Ty Birill est une pizzeria installée dans une ferme du Finistère, qui travaille en circuit court avec les produits de l'exploitation. Le site présente la ferme, sa galerie photo et vidéo, les commandes à emporter, un passage podcast et les informations pratiques. Le client met à jour lui-même horaires et coordonnées.\n\n<ins>**PHP / WordPress**</ins>. J'ai développé un thème entièrement sur mesure, sans thème parent ni constructeur de pages, sur une base **Bedrock** :\n\n WordPress et ses plugins sont gérés comme des dépendances **Composer** (WPackagist) ;\n\n la configuration est séparée par environnement grâce à des fichiers `.env` (développement, staging, production), et l'indexation est désactivée automatiquement sur le staging \n\n une **classe PHP dédiée** utilise la Settings API pour créer une page d'options « Pizzeria » dans l'administration (horaires, adresse, téléphone, courriel) ;\n\n les contenus de la page d'accueil (à propos, vente à emporter, galerie, podcast) sont administrables avec des champs ACF, et les gabarits sont découpés en parties réutilisables (`get_template_part`).\n\n<ins>**JavaScript**</ins>. Architecture en modules ES :\n\n une pizza qui tourne au rythme du défilement (GSAP ScrollTrigger) ;\n\n un menu plein écran animé ;\n\n un sélecteur de thème de couleur (« Majorelle » et « Ajonc »), dont le choix est mémorisé avec `localStorage` ;\n\n un carrousel Swiper mêlant photos et vidéos ;\n\n un lecteur audio pour le podcast.\n\n<ins>**Outillage**</ins>. Workflow Gulp (SCSS, minification), PHP_CodeSniffer, dépôt Git avec environnement de staging. Le code est public sur GitHub.",
    image: "./img/tybirill.webp",
    alternative: "copie d'écran du projet Tybirill",
    width: "1920",
    height: "950",
    lien: "https://dev.olivierraude.me/tybirill/web/",
    github: "https://github.com/olivierraude/wordpress-tybirill",
  },
  {
    id: 5,
    titre: "Franchise Restauration",
    categorie: "Programmation site web",
    languages: ["WordPress", "PHP", "CPT UI", "ACF", "SCSS", "GSAP", "Vanilla JS", "SEO"],
    description:
      "Franchise Restauration est la seule plateforme québécoise entièrement consacrée aux franchises de restauration. Elle met en relation les franchiseurs et les futurs franchisés : répertoire de marques, actualités du secteur et espace annonceurs pour les franchiseurs.PHP / WordPress. J’ai modélisé les franchises avec un type de contenu personnalisé (repertoire) et des taxonomies pour les secteurs d’activité (burger, pizzeria, cuisine du monde, végane…) et les régions, avec des champs ACF Pro. J’ai écrit des requêtes WP_Query sur mesure, filtrées par taxonomie, pour proposer plusieurs façons de parcourir le répertoire : par secteur, par emplacement, franchises en vedette, nouveautés et ordre alphabétique. Le site a ensuite servi de base à Avenir Franchise, l’annuaire généraliste du même réseau, qui reprend la même architecture de données. JavaScript. J’ai développé en JavaScript natif une navigation alphabétique pour filtrer les franchises par lettre, sans rechargement de page, et des animations GSAP.",
    image: "./img/home-franchise-restauration.webp",
    alternative: "copie d'écran de la page d'accueil du projet Franchise Restauration",
    width: "1920",
    height: "950",
    lien: "https://franchise-restauration.ca/",
  },
  {
    id: 6,
    titre: "Automatisation de processus",
    categorie: "Script Bash",
    languages: ["Bash", "Git", "Composer", "NodeJS", "Gulp"],
    description:
      "Création d’un script d’installation des nouveaux projets WP. Le script appelle un dossier boilerplate hébergé sur Github contenant la base du projet, le child theme, le fichier wp-content avec les plugins, fichier gulpfile.js, le composer.json… Au lancement du script, je rentre les données nécessaires pour la création d’un projet prêt au développement avec création de la base de données, sass, minification du CSS et JS dans un dossier dist/ et autoreload à chaque enregistrement des modifications dans l'IDE.",
    image: "./img/script-install.webp",
    alternative: "copie d'écran de l'ide Script de lancement nouveau projet",
    width: "1920",
    height: "950",
    github: "https://github.com/olivierraude/script-new-WP/blob/master/wpinstallpro",
  },
  {
    id: 7,
    titre: "Projetdekip Média",
    categorie: "Programmation site web",
    languages: [
      "WordPress",
      "PHP",
      "CPT UI",
      "ACF",
      "SCSS",
      "GSAP",
      "Vanilla JS",
      "Gulp",
      "Composer",
      "NodeJS",
      "SEO",
    ],
    description:
      "Réalisation d'un site web responsive, thème personnalisé, CSS est codé en SCSS et en respectant la méthode de nommage BEM, animations réalisées avec GSAP et gestion des données dynamiques avec CPT UI et ACF. Site FR/EN réalisé pour l'agence de placement média Projetdekip Media à Montréal.",
    image: "./img/projetdekip.webp",
    alternative: "copie d'écran de la page d'accueil du projet Projetdekip Media",
    width: "1920",
    height: "950",
    lien: "https://www.projetdekip.com/",
  },
  {
    id: 8,
    titre: "Webfolio",
    categorie: "Programmation site web",
    languages: ["ReactJS", "HTML", "SCSS", "GSAP", "CI/CD"],
    description:
      "Réalisation de mon webfolio en ReactJS. Apprentissage de ReactJS, des props, useState/useEffect, des components, création et gestion de l’environnement de développement. J'ai aussi découvert plusieurs librairies Javascript pour la gestion des animations comme Framerjs et Gsap. Le style est codé en SCSS et le site a été déployé originellement sur le cloud d'AWS via la plateforme Amplify, aujourd’hui sur Hostinger.",
    image: "./img/webfolio.webp",
    alternative: "copie d'écran du projet Webfolio",
    width: "1920",
    height: "950",
    //lien : "Vous êtes ici",
    github: "https://github.com/olivierraude/webfolio_site",
  },
];
